import type { CreateSearchInput } from "./searches";
import type { TransactionsQuery } from "./credits";
import type { SpecializedSearchStatus } from "./types";

/**
 * Chaves do TanStack Query em um lugar só.
 *
 * Centralizar evita invalidação errada (ou esquecida) espalhada por hooks.
 */
export const queryKeys = {
  auth: {
    me: () => ["auth", "me"] as const,
    sessions: () => ["auth", "sessions"] as const,
  },
  billing: {
    status: () => ["billing", "status"] as const,
  },
  catalog: {
    plans: () => ["catalog", "plans"] as const,
    serviceCategories: () => ["catalog", "service-categories"] as const,
    topupPackages: () => ["catalog", "topup-packages"] as const,
  },
  credits: {
    all: () => ["credits"] as const,
    wallet: () => ["credits", "wallet"] as const,
    transactions: (query: TransactionsQuery) =>
      ["credits", "transactions", query] as const,
    topups: (page: number) => ["credits", "topups", page] as const,
    topup: (id: string) => ["credits", "topup", id] as const,
    topupQuote: (packageCode: string) =>
      ["credits", "topup-quote", packageCode] as const,
  },
  subscription: {
    current: () => ["subscription", "current"] as const,
  },
  searches: {
    history: (page: number) => ["searches", "history", page] as const,
    detail: (id: string) => ["searches", "detail", id] as const,
    results: (input: CreateSearchInput) => ["searches", "results", input] as const,
  },
  publicOpportunities: {
    search: (params: object) =>
      ["public-opportunities", "search", params] as const,
    highlights: () => ["public-opportunities", "highlights"] as const,
    detail: (id: string) => ["public-opportunities", "detail", id] as const,
  },
  locations: {
    detail: (id: string) => ["locations", "detail", id] as const,
    quote: (id: string) => ["locations", "quote", id] as const,
    unlocked: (page: number) => ["locations", "unlocked", page] as const,
  },
  specializedSearches: {
    all: () => ["specialized-searches"] as const,
    list: (page: number, status?: SpecializedSearchStatus) =>
      ["specialized-searches", "list", page, status ?? null] as const,
    detail: (id: string) => ["specialized-searches", "detail", id] as const,
  },
} as const;
